




































































import { Component, Vue, Prop } from "vue-property-decorator";
import { TradeSide } from "@foxone/api/src/models/market";
import utils from "trade/utils";

@Component
class WyreOrderItem extends Vue {
  @Prop() order;

  get meta() {
    const destAsset = this.order.dest_asset;
    const sourceCurrency = this.order.source_currency;
    const destCurrency = this.order.dest_currency;
    const status = this.order.status;
    const sourceAmount = this.order.source_amount;
    const sourceAmountWithoutFees = this.order.source_amount_without_fees;
    const destAmount = this.order.dest_amount;
    const exchangeRate = this.order.exchange_rate;
    const fee = Number(this.order.source_fee) + Number(this.order.dest_fee);
    const sideMeta = utils.enums.getTradeSideMeta(TradeSide.BID);
    const statusMeta = utils.enums.getWyreStatusMeta(status);

    const destAssetIcon = destAsset.icon;
    const destAssetSymbol = destAsset.symbol;
    const statusText = this.$t(statusMeta.text);
    const statusColor = statusMeta.color;
    return {
      sideText: this.$t(sideMeta.text),
      sideColor: sideMeta.color,
      fee,
      exchangeRate,
      destAssetIcon,
      destAssetSymbol,
      statusText,
      statusColor,
      sourceAmount,
      destAmount,
      destCurrency,
      sourceCurrency,
      sourceAmountWithoutFees
    };
  }
}
export default WyreOrderItem;
